// App-level confirm() replacement. The themed ConfirmModal lives
// inside the app root; child components (InstanceQueueIndicator,
// etc.) trigger it via this bus so they don't have to prop-drill.
//
// app.jsx registers its `_askConfirm` as the handler on mount; any
// caller imports `askConfirm` and awaits the returned promise,
// which resolves true/false exactly like window.confirm.

let handler = null;

export function registerConfirmHandler(fn) {
  handler = typeof fn === 'function' ? fn : null;
}

export function askConfirm(options) {
  if (!handler) return Promise.resolve(true);
  return handler(options);
}
